export enum VesselVisitStatusCodes {
    Cancelled = 'C',
    Completed = 'K',
    Unmoored = 'O',
    Confirmed = 'P',
    Planned = 'PLN',
    Anchored = 'S',
    Announced = 'N',
    Moored = 'V',
    Rejected = 'Z'
}
